export enum CreditUnit {
    Points = 'Points',
    Stars = 'Stars',
    EngagementTrigger = 'EngagementTrigger',
    unknown = 'unknown'
}
